import request from '@/utils/request'

const getInvoice = () => {
  return request({
    url: '/shop/invoice',
    method: 'get'
  })
}

const addInvoice = (params) => {
  return request({
    url: '/shop/invoice',
    data: params,
    method: 'post'
  })
}

const delInvoice = (id) => {
  return request({
    url: `/shop/invoice/${id}`,
    method: 'delete'
  })
}

export {
  getInvoice, // 批量查询发票信息
  addInvoice, // 新增发票信息
  delInvoice // 删除发票信息
}
